export default __webpack_public_path__ + "static/media/k4Logo.5048d2f6.png";